import { motion } from "framer-motion";
import { Calendar, Clock, MapPin } from "lucide-react";

const events = [
  {
    key: "wedding",
    title: "The Wedding",
    subtitle: "Wedding · Ceremony",
    date: "24 June 2026",
    day: "Wednesday",
    time: "9:30 AM onwards",
    city: "Bhandara, Maharashtra",
    note: "Join us as we exchange vows, bless us on our ceremonial union.",
    image:
      "https://images.unsplash.com/photo-1772127822653-4431a9b8c31b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB3ZWRkaW5nJTIwZmxvcmFsJTIwZGVjb3J8ZW58MHx8fHwxNzgwNjQ5MDIyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "reception",
    title: "The Reception",
    subtitle: "An evening to celebrate",
    date: "27 June 2026",
    day: "Saturday",
    time: "7:30 PM onwards",
    city: "Hyderabad, Telangana",
    note: "Dinner, dancing and the start of a new chapter — together.",
    image:
      "https://images.pexels.com/photos/12572754/pexels-photo-12572754.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export default function EventsPage() {
  return (
    <div data-testid="events-page">
      <section
        className="border-b"
        style={{ background: "#FBF5EA", borderColor: "#EFE6D2" }}
      >
        <div className="max-w-5xl mx-auto px-5 sm:px-12 py-20 sm:py-28 text-center">
          <p className="overline">
            <span className="divider-line mr-4" />
            The Celebrations
            <span className="divider-line ml-4" />
          </p>
          <h1 className="font-serif-wb mt-7 text-4xl sm:text-5xl lg:text-7xl tracking-tighter">
            Two States.{" "}
            <span className="italic" style={{ color: "var(--wb-primary)" }}>
              One story.
            </span>
          </h1>
          <p
            className="mt-7 max-w-xl mx-auto text-sm sm:text-base leading-relaxed"
            style={{ color: "var(--wb-text-muted)" }}
          >
            We're celebrating in cities that shaped us — we'd love nothing
            more than for you to be there.
          </p>
        </div>
      </section>

      <section
        data-testid="events-section"
        style={{ background: "#F5EBD3" }}
      >
        <div className="max-w-7xl mx-auto px-5 sm:px-12 py-20 md:py-28">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-7 lg:gap-12">
            {events.map((e, i) => (
              <motion.article
                key={e.key}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.8, delay: i * 0.12 }}
                data-testid={`event-card-${e.key}`}
                className="bg-white border border-[#EFE6D2] flex flex-col overflow-hidden"
              >
                <div className="relative h-60 sm:h-72 overflow-hidden">
                  <img
                    src={e.image}
                    alt={e.title}
                    className="w-full h-full object-cover transition-transform duration-[1200ms] hover:scale-105"
                  />
                  <div className="absolute bottom-4 left-6 text-white">
                    <p className="overline" style={{ color: "#FBF5EA" }}>
                      {e.subtitle}
                    </p>
                  </div>
                </div>

                <div className="p-8 sm:p-12 flex-1 flex flex-col">
                  <h3 className="font-serif-wb text-3xl sm:text-4xl tracking-tight">
                    {e.title}
                  </h3>

                  <p
                    className="overline mt-4"
                    style={{ color: "var(--wb-primary)" }}
                  >
                    {e.day}
                  </p>

                  <div className="mt-6 space-y-3" style={{ color: "var(--wb-text)" }}>
                    <div className="flex items-center gap-3">
                      <Calendar size={16} style={{ color: "var(--wb-primary)" }} />
                      <span className="font-sans-wb text-sm">{e.date}</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <Clock size={16} style={{ color: "var(--wb-primary)" }} />
                      <span className="font-sans-wb text-sm">{e.time}</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <MapPin size={16} style={{ color: "var(--wb-primary)" }} />
                      <span className="font-sans-wb text-sm">{e.city}</span>
                    </div>
                  </div>

                  <p
                    className="mt-7 leading-[1.85] text-[0.95rem]"
                    style={{ color: "var(--wb-text-muted)" }}
                  >
                    {e.note}
                  </p>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
